module.exports = __webpack_public_path__ + "img/red-1-oval-striped.a043521b.svg";